const ISO_DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;

export const parseFormCSIsoDate = (value) => {
  if (!ISO_DATE_REGEX.test(String(value || ""))) return null;

  const [year, month, day] = String(value).split("-").map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));

  if (
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() + 1 !== month ||
    date.getUTCDate() !== day
  ) {
    return null;
  }

  return date;
};

export const isFormCSBasisPeriodLongerThan12Months = ({
  basisPeriodFrom,
  basisPeriodTo,
} = {}) => {
  const start = parseFormCSIsoDate(basisPeriodFrom);
  const end = parseFormCSIsoDate(basisPeriodTo);
  if (!start || !end || end < start) return false;

  const twelveMonthEnd = new Date(start);
  twelveMonthEnd.setUTCFullYear(twelveMonthEnd.getUTCFullYear() + 1);
  twelveMonthEnd.setUTCDate(twelveMonthEnd.getUTCDate() - 1);

  return end > twelveMonthEnd;
};
